export default __webpack_public_path__ + "static/welcome-photo-landscape-ec4e62934f1aa92d3c30a282a34f6391.jpg";